export default __webpack_public_path__ + "static/media/Childish_Gambino_Redbone.9443d58e.mp3";